import { Component } from '@angular/core';
import {TIMELINE_UNOX} from './data';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent {
  timeline = TIMELINE_UNOX;
}
